import { resetAllTablesExceptPaginationAndColumns } from "@/stores/useTableStore";

import { useAuth } from "../../../context/Auth/AuthProvider";

const useUsersValues = () => {
  const { setErrorMessageFromServer, removeAlert } = useAuth();

  const resetAllPreviousValues = () => {
    resetAllTablesExceptPaginationAndColumns();

    setErrorMessageFromServer(false);
    // should remove unauthorized message if user was not authenticated previously
    removeAlert?.();
  };
  return { resetAllPreviousValues };
};

export default useUsersValues;
